import { App } from '@ps20-frontend/frontend-models';

//TODO: Auslaendische Adresse aus Angebots ID Entfernen
//TODO: AngebotsID an allen stellen verwenden wo AngebotsID allein steht
export interface AngebotsId {
  appId: App;
  angebotsId?: string;
  angebotsdatum?: string;
  containsAuslaendischeAdresse?: boolean;
}

export function isAngebotsIdEqual(angebot1: AngebotsId, angebot2: AngebotsId): boolean {
  if (!angebot1 || !angebot2) {
    return false;
  }
  return angebot1.angebotsId === angebot2.angebotsId && angebot1.appId === angebot2.appId;
}
